import $ from 'jquery';
import _ from 'lodash';

export const initADAOverride = function (initADA) {
  return function () {
    var _ = this;
    initADA.call(this);
    if (_.$dots !== null) {
      _.$dots
        .attr('role', 'tablist')
        .find('li')
        .each(function (i) {
          $(this)
            .find('button')
            .first()
            .attr({
              'aria-label': i + 1 + ' of ' + _.slideCount,
            });
        });
    }
  };
};
